import { T_SUBSCRIPTION_CARD_PAGE_CONSTANTS } from './TYPES'

const DE_SUBSCRIPTION_CARD_PAGE_CONSTANTS: T_SUBSCRIPTION_CARD_PAGE_CONSTANTS =
  {
    CHAMPION: {
      TITLE: 'Champion',
      DESCRIPTION: 'Beste Wahl für {{minUser}}+ Benutzer',
      TENURE_LABEL_TEXT: 'Wählen Sie die Laufzeit',
      TENURES_MAP: {
        6: '6 Monate',
        12: '1 Jahr',
        LIFETIME: 'Lebenslang'
      },
      YOU_WILL_PAY_TEXT: 'SIE ZAHLEN',
      YOU_WILL_PAY_USER_TEXT: 'Benutzer',
      BUY_CTA_TEXT: 'Plan kaufen'
    },
    PREMIUM: {
      TITLE: 'Premium',
      DESCRIPTION: 'Beste Wahl für {{minUser}}+ Benutzer',
      TENURE_LABEL_TEXT: 'Wählen Sie die Laufzeit',
      TENURES_MAP: {
        6: '6 Monate',
        12: '1 Jahr',
        LIFETIME: 'Lebenslang'
      },
      YOU_WILL_PAY_TEXT: 'SIE ZAHLEN',
      YOU_WILL_PAY_USER_TEXT: 'Benutzer',
      BUY_CTA_TEXT: 'Plan kaufen'
    },
    ADVENTURE: {
      TITLE: 'Abenteuer',
      DESCRIPTION: 'Beste Wahl für Einzelpersonen',
      TENURE_LABEL_TEXT: 'Wählen Sie die Laufzeit',
      TENURES_MAP: {
        6: '6 Monate',
        12: '1 Jahr',
        LIFETIME: 'Lebenslang'
      },
      YOU_WILL_PAY_TEXT: 'SIE ZAHLEN',
      YOU_WILL_PAY_USER_TEXT: 'Benutzer',
      BUY_CTA_TEXT: 'Plan kaufen'
    }
  }

export default DE_SUBSCRIPTION_CARD_PAGE_CONSTANTS
